import set from 'lodash/set';
import state from 'store/state/slot';
import types from 'store/types/slot';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data } = action;

  switch (action.type) {
    case types.SLOT_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
